import { render, staticRenderFns } from "./tieBro.vue?vue&type=template&id=643343b3&scoped=true"
import script from "./tieBro.vue?vue&type=script&lang=js"
export * from "./tieBro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643343b3",
  null
  
)

export default component.exports